import { __awaiter, __extends, __generator, __read } from "tslib";
import { queryCache } from '@office-start/data-fetching';
import { loadModules } from '../Bootstrapper';
import { Module } from '.';
import { ModuleError } from './ModuleError';
var SearchModules = /** @class */ (function (_super) {
    __extends(SearchModules, _super);
    function SearchModules(searchSettings) {
        var _this = _super.call(this, 'Search_Modules') || this;
        _this.searchSettings = searchSettings;
        return _this;
    }
    SearchModules.prototype.initializeModule = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, hostAppId, cdnOptions, searchConfig, featureGates, options, query, searchModules;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.searchSettings.getHostAppId(),
                            this.searchSettings.getCdnOptions(),
                            this.searchSettings.getSearchConfig(),
                            this.searchSettings.getFeatureGates(),
                        ])];
                    case 1:
                        _b = __read.apply(void 0, [_c.sent(), 4]), hostAppId = _b[0], cdnOptions = _b[1], searchConfig = _b[2], featureGates = _b[3];
                        options = {
                            hostAppId: hostAppId,
                            cdnOptions: cdnOptions,
                            isPayForPlayEnabled: ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.searchGates) === null || _a === void 0 ? void 0 : _a.searchIsPayForPlayEnabled) || false,
                            microsoftSearchBootstrapperUrlOverridesEnabled: searchConfig.microsoftSearchBootstrapperUrlOverridesEnabled,
                            microsoftSearchBootstrapperKillSwitchesActive: searchConfig.microsoftSearchBootstrapperKillSwitchesActive,
                        };
                        query = ['SearchModules'];
                        return [4 /*yield*/, queryCache.fetchQuery(query, function () { return loadModules(options); }, {
                                cacheTime: Infinity,
                                staleTime: Infinity,
                                onError: function () {
                                    throw new ModuleError('Search_Modules', 'Fetching_Error');
                                },
                            })];
                    case 2:
                        searchModules = _c.sent();
                        this.module.resolve(searchModules);
                        return [2 /*return*/];
                }
            });
        });
    };
    return SearchModules;
}(Module));
export { SearchModules };
//# sourceMappingURL=SearchModules.js.map